import * as sysUser from "../api/sysUser";

export default {
  namespaced: true,
  state: {
    loading: false,
    user: null,
  },
  getters: {
    status(state) {
      if (state.loading) {
        return "loading";
      } else if (state.user) {
        return "login";
      } else {
        return "unlogin";
      }
    },
  },
  mutations: {
    setLoading(state, params) {
      state.loading = params;
    },
    setUser(state, params) {
      if (params?.menu) {
        params.menu.sort((a, b) => parseInt(a.id) - parseInt(b.id));
      }
      state.user = params;
    },
  },
  actions: {
    async login(ctx, param) {
      ctx.commit("setLoading", true);
      const res = await sysUser.login(param);
      if (res) {
        ctx.commit("setUser", res);
      }
      ctx.commit("setLoading", false);
      return res;
    },
    async resLogin(ctx) {
      return new Promise(async (resolve, reject) => {
        ctx.commit("setLoading", true);
        const res = await sysUser.isTokenExpire();
        if (res) {
          ctx.commit("setUser", res);
          resolve(res);
        } else {
          reject();
        }
        ctx.commit("setLoading", false);
      });
    },
    async loginOut(ctx, param) {
      ctx.commit("setLoading", true);
      await sysUser.logout(param);
      ctx.commit("setUser", null);
      ctx.commit("setLoading", false);
    },
  },
  modules: {},
};
